(() => {
  const config = window.__riseHeaderSearchAssets || {};
  if (!config.searchFormScript) return;

  let searchAssetsPromise;

  const loadScript = (src) =>
    new Promise((resolve, reject) => {
      if (!src || document.querySelector(`script[src="${src}"]`)) {
        resolve();
        return;
      }
      const script = document.createElement('script');
      script.src = src;
      script.async = false;
      script.onload = () => resolve();
      script.onerror = reject;
      document.head.appendChild(script);
    });

  const loadStyle = (href) => {
    if (!href || document.querySelector(`link[href="${href}"]`)) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  };

  const loadHeaderSearchAssets = () => {
    if (searchAssetsPromise) return searchAssetsPromise;

    searchAssetsPromise = loadScript(config.searchFormScript)
      .then(() => {
        if (!config.predictiveSearchEnabled) return Promise.resolve();
        loadStyle(config.predictiveSearchStyle);
        loadStyle(config.priceStyle);
        return loadScript(config.predictiveSearchScript);
      })
      .catch(() => {
        searchAssetsPromise = null;
      });

    return searchAssetsPromise;
  };

  window.__riseLoadHeaderSearchAssets = loadHeaderSearchAssets;

  const scheduleHeaderSearchAssets = () => {
    if (searchAssetsPromise) return;

    const run = () => loadHeaderSearchAssets();
    if (window.RiseGlobalCwvPatches?.scheduleAfterInteraction) {
      window.RiseGlobalCwvPatches.scheduleAfterInteraction(run);
    } else {
      window.requestAnimationFrame(() => window.requestAnimationFrame(run));
    }
  };

  const primeLoader = () => {
    scheduleHeaderSearchAssets();
    document.removeEventListener('focusin', handleFocusIn, true);
    document.removeEventListener('pointerover', handlePointerOver, true);
    document.removeEventListener('touchstart', handleTouchStart, true);
  };

  const shouldPrime = (target) =>
    target instanceof Element &&
    Boolean(target.closest('.header__search, .search-modal, .search__input, .header__icon--search'));

  const handleFocusIn = (event) => {
    if (shouldPrime(event.target)) primeLoader();
  };

  const handlePointerOver = (event) => {
    if (shouldPrime(event.target)) primeLoader();
  };

  const handleTouchStart = (event) => {
    if (shouldPrime(event.target)) primeLoader();
  };

  document.addEventListener('focusin', handleFocusIn, true);
  document.addEventListener('pointerover', handlePointerOver, true);
  document.addEventListener('touchstart', handleTouchStart, { passive: true, capture: true });
})();
